import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcReadingEbook } from "react-icons/fc";
import { FaCheckCircle } from "react-icons/fa";
import { FaCircleXmark } from "react-icons/fa6";
const ViewSchedule = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [data2, setData2] = useState();
  let { id } = useParams();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/labourTraining/getlabourTraining/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setData2(res.data?.labourSchedule);
        } else {
          Toast("error", "Error while getting schedule!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);
  const returnClassname = (status) => {
    if (status === "Day 1") {
      return "badge bg-lime  text-white";
    }
    if (status === "Day 2") {
      return "badge bg-purple  text-white";
    }
    if (status === "Day 3") {
      return "badge bg-azure  text-white";
    }
    if (status === "Day 4") {
      return "badge bg-pink  text-white";
    }
    if (status === "Day 4") {
      return "badge bg-green  text-white";
    }
    if (status === "Day 5") {
      return "badge bg-yellow  text-white";
    }
    if (status === "Day 6") {
      return "badge bg-cyan  text-white";
    }
    if (status === "Day 7") {
      return "badge bg-teal  text-white";
    }
    if (status === "Day 8") {
      return "badge bg-orange  text-white";
    }
  };
  const getBG = (date) => {
    let newDt = new Date().toISOString().split("T")[0];

    if (date == newDt) {
      return "bg-primary-lt";
    }
    return "";
  };
  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcReadingEbook
                    className="fs-2 me-1"
                    style={{ color: "green" }}
                  />{" "}
                  Labour Training
                </h2>
                <h4 className="text-muted">
                  Track & manage your training progress.
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <a href={"/labour-training"} className="btn btn-primary">
                    <FcReadingEbook className="fs-3 me-2" />
                    ALL Schedules
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card table-responsive">
                <table className="table table-striped table-vcenter">
                  <thead>
                    <tr>
                      <th>Specs</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data && (
                      <tr>
                        <td>Client</td>
                        <td>
                          {(
                            data?.Client?.businessName ||
                            data?.Client?.clientName ||
                            "N/A"
                          ).toUpperCase()}
                        </td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td>Address</td>
                        <td>
                          {(
                            data?.Client?.farmAddress ||
                            data?.Client?.businessName ||
                            "N/A"
                          ).toUpperCase()}
                        </td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td>Trainee Name</td>
                        <td>{(data?.labourName || "N/A").toUpperCase()}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td>Training start date</td>
                        <td>{(data?.startDate || "N/A").toUpperCase()}</td>
                      </tr>
                    )}

                    {data2 && (
                      <tr>
                        <td>Total Activity</td>
                        <td>{data2?.length || "N/A"}</td>
                      </tr>
                    )}
                    {data2 && (
                      <tr>
                        <td>Total Activity Done</td>
                        <td>
                          {data2?.filter((el) => el.activityDone).length || "0"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {data2 && (
                  <div className="table-responsive">
                    <table className="fs-5 table  table-vcenter">
                      <thead>
                        <tr>
                          <th>Day/Date</th>
                          <th>Activity</th>
                          <th>mark Done</th>
                          <th>activity Done date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data2?.map((lineItem, index) => (
                          <tr key={index} className={getBG(lineItem?.date)}>
                            <td>
                              <span>{lineItem.day}</span>
                              <br />
                              <span>{lineItem.date}</span>
                            </td>
                            <td>
                              <span className={returnClassname(lineItem.day)}>
                                {lineItem.work}
                              </span>
                              <br />
                              <span>{lineItem.activity || "N/A"}</span>
                            </td>
                            <td className="ms-2">
                              {lineItem.activityDone ? (
                                <FaCheckCircle
                                  fontSize={"20px"}
                                  color="#34A853"
                                />
                              ) : (
                                <FaCircleXmark
                                  fontSize={"20px"}
                                  color="#D80001"
                                />
                              )}
                            </td>
                            <td>{lineItem.activityDoneDate || "N/A"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    <SimpleButton
                      buttonText="Update Schedule"
                      href={`/labour-training/edit/${id}`}
                    />
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewSchedule;
